module.exports = __webpack_public_path__ + "static/media/tree.ae78e3fd.png";